import type { CityConfig } from "@/pages/city-template/types";

export const jaffreyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jaffrey",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "jaffrey",
  route: "/cities/jaffrey",
  title: "Emergency & Expedited Passport Services Jaffrey NH | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jaffrey, NH — as fast as 24 hours. No Jaffrey passport agency. Fast Passport Center couriers to the Boston Passport Agency at Tip O'Neill Federal Building, about 100 miles southeast. A+ BBB rated. Serving Rindge, Peterborough, Dublin, and all Monadnock Region travelers heading abroad for adventure, business, or family.",
  h1: "Emergency & Expedited Passport Services in Jaffrey, NH",
  heroSubtitle: "Jaffrey sits at the base of the iconic Mount Monadnock in Cheshire County — one of the most hiked mountains in the world and the heart of southwestern New Hampshire's Monadnock Region. Known for its strong community spirit, the historic Jaffrey Meetinghouse, and outdoor recreation culture, Jaffrey attracts hikers, nature enthusiasts, and families seeking the quintessential New England small-town experience. Fast Passport Center's registered couriers deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building so you get a new or renewed passport as fast as 24 hours — whether you're a Monadnock hiker heading to an international trekking expedition, a Franklin Pierce University student studying abroad, or a Jaffrey family embarking on the trip of a lifetime overseas.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Jaffrey%20New%20Hampshire%20downtown%20with%20Mount%20Monadnock%20visible%20in%20background%20during%20autumn%20foliage%20season%2C%20classic%20white%20church%20steeple%20and%20historic%20New%20England%20Main%20Street%20with%20small%20shops%20and%20autumn%20trees%2C%20wide%20angle%20landscape%20photography%20with%20vibrant%20fall%20colors%20and%20mountain%20backdrop&width=1800&height=700&seq=jaffrey-nh-hero-001&orientation=landscape",
  heroImageAlt: "Jaffrey New Hampshire downtown with Mount Monadnock and autumn foliage",
  geoPosition: "42.8140;-72.0231",
  geoPlacename: "Jaffrey, New Hampshire",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
    distance: "Approximately 100 miles from Jaffrey — about 2 hours via NH-124 and I-93 south",
  },
  nearbyCitiesZips: [
    { name: "Jaffrey", zips: "03452" },
    { name: "Rindge", zips: "03461" },
    { name: "Peterborough", zips: "03458" },
    { name: "Dublin", zips: "03444" },
    { name: "New Ipswich", zips: "03071" },
    { name: "Greenville", zips: "03048" },
    { name: "Temple", zips: "03084" },
    { name: "Sharon", zips: "03458" },
    { name: "Fitzwilliam", zips: "03447" },
    { name: "Winchendon", zips: "01475" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Boston Passport Agency — about 100 miles from Jaffrey via NH-124 and I-93" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Monadnock Region Service", desc: "Serving Jaffrey, Rindge, Peterborough, Dublin, and all southwestern New Hampshire" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Jaffrey case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in New Hampshire", route: "/states/new-hampshire" },
    { name: "Expedited passport in Manchester NH", route: "/cities/manchester" },
    { name: "Urgent passport in Jaffrey NH", route: "/cities/jaffrey" },
    { name: "New Hampshire passport hub", route: "/states/new-hampshire" },
    { name: "Fast passport in Keene NH", route: "/cities/keene" },
    { name: "Expedited passport in Peterborough NH", route: "/cities/peterborough" },
    { name: "Emergency passport in Concord NH", route: "/cities/concord-nh" },
  ],
  fpcOfficeAddress: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
  fpcOfficeNote: "Fast Passport Center serves Jaffrey remotely via secure courier. Our registered couriers hand-deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building — approximately 100 miles southeast. Jaffrey's location along NH-124 and the Route 202/I-93 corridor makes Boston courier routing reliable year-round. Our dedicated agents ensure Monadnock Region travelers, from outdoor enthusiasts to Franklin Pierce University students, never need to navigate the 2-hour drive to Boston for passport processing.",
  fpcOfficeDistance: "Serving all of Cheshire County's Monadnock Region and the Jaffrey-Rindge area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Jaffrey, Rindge, Peterborough, Dublin, and the entire Monadnock Region. From Mount Monadnock hikers heading abroad to Franklin Pierce University students studying overseas, we help Jaffrey travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Jaffrey and nearby communities including Rindge, Peterborough, Dublin, New Ipswich, Greenville, Fitzwilliam, and the greater Monadnock Region — plus Winchendon, Massachusetts just across the state line.",
  howItWorksIntro: "Most Jaffrey travelers complete everything online and ship documents overnight. At approximately 100 miles from Boston, Fast Passport Center provides fast courier turnaround for Monadnock Region residents — eliminating the 2-hour drive through NH-124 and I-93 to Boston.",
  mistakesIntro: "Jaffrey travelers, including Mount Monadnock outdoor enthusiasts and Monadnock Region families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Jaffrey and Monadnock Region travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Jaffrey? Here are the most common ones we hear from Monadnock Region and Cheshire County travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv/index.htm",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at Causeway Street",
        "Life-or-death emergencies only",
        "100 miles to Boston (2 hours via NH-124/I-93)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Monadnock hikers",
        "Perfect for Franklin Pierce students",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from BOS or MHT",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Jaffrey is 100 miles from the Boston Passport Agency — our courier service saves Monadnock Region travelers the drive through NH-124 and Boston traffic.",
      bullets: ["Cheshire County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in the Monadnock Region",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Jaffrey adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Jaffrey and Monadnock Region"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Jaffrey and Cheshire County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Jaffrey and Monadnock Region residents with DS-64 form guidance and courier routing to Boston.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Boston agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Cheshire County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Jaffrey and Cheshire County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jaffrey NH", description: "Urgent passport processing for Jaffrey, NH travelers via Boston Passport Agency courier — 100 miles from Jaffrey." },
    { name: "Passport Renewal Jaffrey NH", description: "Fast passport renewal for Jaffrey and Cheshire County, New Hampshire residents." },
    { name: "New Passport Jaffrey NH", description: "First-time passport application assistance for Jaffrey and Monadnock Region area residents." },
    { name: "Lost Passport Jaffrey NH", description: "Passport replacement for lost or stolen passports for Jaffrey and Cheshire County residents." },
    { name: "Child Passport Jaffrey NH", description: "Minor passport services for Jaffrey and Monadnock Region families." },
    { name: "Name Change Passport Jaffrey NH", description: "Passport name change service for Jaffrey, NH residents." },
  ],
  testimonials: [
    {
      name: "Chris D.",
      location: "Jaffrey, NH — Mount Monadnock Guide",
      rating: 5,
      text: "I lead hiking expeditions locally and got invited to guide a trek in Patagonia. Booked the trip, then realized my passport had less than 4 months left — Chile requires 6. Fast Passport Center renewed it in 6 business days during peak fall foliage season. Their courier handled everything from Jaffrey. I was on a plane to Santiago with my new passport in hand.",
      service: "Passport Renewal",
    },
    {
      name: "Rebecca M.",
      location: "Rindge, NH — Franklin Pierce University",
      rating: 5,
      text: "FPU senior who got a last-minute internship opportunity in Dublin, Ireland. My passport had expired sophomore year and I never renewed it. Fast Passport Center processed a new passport in 8 business days. The agent walked me through every step — I had no idea how the process worked. I made it to Ireland with time to spare before my internship started.",
      service: "New Passport",
    },
    {
      name: "The W Family",
      location: "Peterborough, NH",
      rating: 5,
      text: "Family trip to Costa Rica — our kids' first time out of the country. Two adult renewals plus two child passports. Fast Passport Center coordinated everything, including helping us find an acceptance facility for the DS-11 applications. All four passports arrived in 9 business days. The kids are still talking about the sloths and monkeys.",
      service: "Family Passport Package",
    },
    {
      name: "Linda G.",
      location: "Dublin, NH",
      rating: 5,
      text: "Retired librarian who finally decided to take the European river cruise I've dreamed about for 20 years. Realized my passport expired during COVID and I completely forgot. Fast Passport Center got me renewed in 7 business days with white-glove service. The agent was incredibly patient with all my questions — I'm not tech-savvy and they walked me through everything over the phone.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "jaf-1",
      name: "Jaffrey Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "36 Main St",
      city: "Jaffrey",
      state: "NH",
      zip: "03452",
      phone: "(603) 532-7784",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Jaffrey — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Jaffrey and the southern Monadnock Region. Located on Main Street in the village center. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "jaf-2",
      name: "Rindge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1226 NH-119",
      city: "Rindge",
      state: "NH",
      zip: "03461",
      phone: "(603) 899-6108",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Rindge — 5 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rindge and Franklin Pierce University community. Convenient for southern Monadnock Region residents.",
      icon: "ri-mail-line",
    },
    {
      id: "jaf-3",
      name: "Peterborough Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "23 Grove St",
      city: "Peterborough",
      state: "NH",
      zip: "03458",
      phone: "(603) 924-3251",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Peterborough — 7 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility serving the Peterborough and eastern Monadnock Region. More appointment availability than smaller post offices.",
      icon: "ri-mail-line",
    },
    {
      id: "jaf-4",
      name: "Keene Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "196 Main St",
      city: "Keene",
      state: "NH",
      zip: "03431",
      phone: "(603) 352-0343",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Keene — 16 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in Cheshire County. More appointment slots and extended hours. About 20 minutes west of Jaffrey.",
      icon: "ri-mail-line",
    },
    {
      id: "jaf-5",
      name: "Cheshire County Registry of Deeds",
      type: "County Passport Acceptance",
      address: "33 West St",
      city: "Keene",
      state: "NH",
      zip: "03431",
      phone: "(603) 352-0401",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Keene — 16 miles west",
      website: "https://www.co.cheshire.nh.us",
      websiteLabel: "Cheshire County Government",
      notes: "County-level passport acceptance serving all Cheshire County residents including Jaffrey, Rindge, and the Monadnock Region.",
      icon: "ri-government-line",
    },
    {
      id: "jaf-6",
      name: "Winchendon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Pleasant St",
      city: "Winchendon",
      state: "MA",
      zip: "01475",
      phone: "(978) 297-0721",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Winchendon, MA — 8 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Just across the Massachusetts state line. Convenient for Jaffrey and Rindge residents near the MA border.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Boston Agency", agency: "100 miles — 2 hour drive via NH-124 and I-93 plus Boston traffic", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-compass-line",
      title: "Not Checking Six-Month Passport Validity Before Booking International Trekking Expeditions",
      description: "Jaffrey's outdoor recreation community — with Mount Monadnock in their backyard — frequently books international trekking trips to destinations like Nepal, Peru, New Zealand, and the Alps. Many of these countries require 6 months passport validity beyond your return date. Hikers who book expeditions 6+ months out often discover their passport expires within that window.",
    },
    {
      icon: "ri-book-open-line",
      title: "Franklin Pierce Students Missing the Passport Deadline for Study Abroad",
      description: "Franklin Pierce University students in Rindge accepted to study abroad programs often underestimate passport processing timelines. Between acceptance notification, passport application, and visa processing, the combined timeline can stretch to 10–12 weeks. Students should apply for or renew their passport the semester BEFORE their abroad term — not the month before departure.",
    },
    {
      icon: "ri-image-line",
      title: "Rural Photo Services Using Incorrect Passport Photo Specifications",
      description: "Small-town photo services in the Jaffrey-Rindge area may use older equipment or be unfamiliar with current State Department photo standards. Photos must be exactly 2x2 inches, pure white background, neutral expression, no glasses. Even slight variations in background color or head size can trigger rejection. Always verify photos meet current specs.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Assuming Keene Has a Passport Agency",
      description: "Keene is the largest city in Cheshire County and the Monadnock Region's commercial hub, leading some Jaffrey residents to assume it has a passport agency. It does not. Keene has acceptance facilities (post office, county registry) but no passport agency. The closest passport agency is Boston — 100 miles southeast.",
    },
    {
      icon: "ri-global-line",
      title: "Passport Book vs. Card Confusion at the Canadian Border",
      description: "Jaffrey residents are within a few hours' drive of Quebec (via I-91). Frequent cross-border travelers sometimes use a passport card, which is fine for land crossings into Canada. But if your travel plans involve flying internationally — even just to Montreal — you need a passport book. Passport cards are not valid for international air travel under any circumstances.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Until Peak Fall Foliage Season When Local Facilities Are Overwhelmed",
      description: "The Monadnock Region sees heavy tourism during September–October peak foliage. Jaffrey and Peterborough area acceptance facilities book appointments 2–4 weeks out during this period. If you need a DS-11 in-person application during foliage season, schedule your appointment well in advance or use Fast Passport Center's courier service to skip the acceptance facility for eligible renewals.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Jaffrey, Peterborough, or Keene." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Boston Passport Agency — 100 miles southeast via NH-124 and I-93." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Boston Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Jaffrey or Monadnock Region address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Jaffrey from the Boston passport agency?",
      a: "Jaffrey is approximately 100 miles from the Boston Passport Agency at the Tip O'Neill Federal Building on Causeway Street — about 2 hours southeast via NH-124 east to I-93 south into Boston. The Boston agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments typically take 2–3 weeks to secure.",
    },
    {
      q: "Is there a passport agency in Keene or anywhere in Cheshire County?",
      a: "No. There is no passport agency anywhere in Cheshire County or southwestern New Hampshire. The closest passport agency to Jaffrey is the Boston Passport Agency — 100 miles southeast. Keene has passport acceptance facilities (post office, county registry) but these are for application intake only, not expedited processing.",
    },
    {
      q: "Can I get a passport at the Jaffrey Post Office?",
      a: "Yes. The Jaffrey Post Office at 36 Main St is a passport acceptance facility — it accepts DS-11 applications and verifies identity documents. However, it does not process or expedite passports. Applications are forwarded to the National Passport Center for standard processing, which takes 6–10 weeks for routine service. For faster processing, use Fast Passport Center's courier service to Boston.",
    },
    {
      q: "Where can I get passport photos in Jaffrey?",
      a: "The closest photo services are at CVS Pharmacy in Peterborough (3 Grove St, about 7 miles north) and Walgreens in Keene (354 Winchester St, about 16 miles west). Both offer passport photo services that meet 2x2 inch white background specifications. Call ahead to confirm photo services are available.",
    },
    {
      q: "How fast can I get an emergency passport in Jaffrey?",
      a: "Emergency processing for Jaffrey residents is typically 24–48 hours via courier to Boston. The Monadnock Region's position along the NH-124/I-93 corridor ensures reliable overnight routing to Boston year-round. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Can Fast Passport Center help Franklin Pierce University students with study abroad passports?",
      a: "Absolutely. We regularly assist FPU students in Rindge with study abroad passport processing. Our 2–9 business day courier service is ideal for students on semester timelines. We handle document review, photo verification, and secure submission — no need to drive to Boston. Start your passport process the semester before your abroad program.",
    },
    {
      q: "I'm a Monadnock hiker heading to an international trek — how early should I start?",
      a: "International trekkers from the Jaffrey area should start passport preparation at least 3–4 months before any international expedition. Destinations like Nepal (Everest Base Camp), Peru (Inca Trail), and Tanzania (Kilimanjaro) require visas in addition to passports. The combined passport-plus-visa timeline can run 8–12 weeks, and many trekking companies require passport copies at booking.",
    },
    {
      q: "Does the Rindge Post Office accept passport applications?",
      a: "Yes. The Rindge Post Office at 1226 NH-119 accepts passport applications. It's especially convenient for Franklin Pierce University students and faculty. Call (603) 899-6108 for an appointment. Hours are limited — Monday through Friday, 9 AM to 3:30 PM.",
    },
    {
      q: "Can you serve Dublin and New Ipswich residents as well?",
      a: "Absolutely. Fast Passport Center serves the entire Monadnock Region including Dublin, New Ipswich, Greenville, Temple, Fitzwilliam, Sharon, and surrounding communities. Document pickup is available throughout Cheshire County and the southern Monadnock Region — plus across the border in Winchendon and Ashburnham, Massachusetts.",
    },
    {
      q: "What's the closest airport to Jaffrey for international flights?",
      a: "Jaffrey travelers typically fly from Manchester-Boston Regional Airport (MHT, about 45 miles northeast), Boston Logan International Airport (BOS, about 100 miles southeast), or Bradley International Airport (BDL, about 80 miles southwest in Connecticut). BOS offers the most international direct routes; MHT and BDL serve mainly domestic connections with some international service.",
    },
    {
      q: "Does winter weather affect courier service from the Jaffrey area?",
      a: "Winter weather in the Monadnock Region can be challenging, but NH-124 and I-93 are maintained as priority state routes year-round. Overnight courier services operate reliably even during winter storms. For winter travel from Jaffrey, we recommend starting the passport process at least 4 weeks before departure to allow buffer time.",
    },
    {
      q: "My family in Rindge is planning a trip to Canada — do we need passports for our kids?",
      a: "Yes. All U.S. citizens, including infants and children, need a valid U.S. passport for international air travel to Canada. For land crossings from New Hampshire to Quebec (about 2–3 hours north via I-91), children under 16 can use a birth certificate instead of a passport — but a passport is always recommended as it simplifies crossing and is required if you fly.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Peterborough", address: "3 Grove St, Peterborough, NH 03458", hours: "Mon–Sun: 8AM–8PM" },
    { name: "Walgreens — Keene", address: "354 Winchester St, Keene, NH 03431", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Keene", address: "7 Ash Brook Rd, Keene, NH 03431", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walmart Photo — Rindge", address: "14 N Park Ave, Rindge, NH 03461", hours: "Mon–Sun: 8AM–8PM" },
    { name: "UPS Store — Keene", address: "149 Emerald St, Keene, NH 03431", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "FedEx Office — Nashua", address: "293 Daniel Webster Hwy, Nashua, NH 03060", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "NH DMV — Keene", address: "149 Emerald St, Keene, NH 03431", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Closest DMV to Jaffrey. REAL ID, driver's license, and state ID services for Monadnock Region residents. About 16 miles west.", featured: true },
    { name: "NH DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8:00AM–4:30PM", note: "State headquarters DMV with full services. About 50 miles northeast of Jaffrey.", featured: false },
    { name: "NH DMV — Nashua", address: "110 Broad St, Nashua, NH 03062", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Southern NH DMV option. About 40 miles southeast of Jaffrey. Full services available.", featured: false },
  ],
  airports: [
    {
      code: "MHT",
      name: "Manchester-Boston Regional Airport",
      distance: "45 miles northeast of Jaffrey",
      address: "1 Airport Rd, Manchester, NH 03103",
      note: "New Hampshire's largest airport with domestic and limited international routes. About 1 hour from Jaffrey via NH-101. Most convenient airport for Monadnock Region travelers.",
      flightUrl: "https://www.flymanchester.com/",
      flightLabel: "MHT Airport",
      featured: true,
    },
    {
      code: "BOS",
      name: "Boston Logan International Airport",
      distance: "100 miles southeast of Jaffrey",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "New England's largest international gateway with direct flights worldwide. About 2 hours from Jaffrey. Co-located with the Boston Passport Agency.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "BOS Airport",
      featured: false,
    },
    {
      code: "BDL",
      name: "Bradley International Airport",
      distance: "80 miles southwest of Jaffrey",
      address: "11 Schoephoester Rd, Windsor Locks, CT 06096",
      note: "Connecticut's largest airport with domestic and some international routes. About 1 hour 30 minutes from Jaffrey via I-91 south. Alternative for southern Monadnock Region travelers.",
      flightUrl: "https://www.bradleyairport.com/",
      flightLabel: "BDL Airport",
      featured: false,
    },
    {
      code: "PVD",
      name: "Rhode Island T.F. Green International Airport",
      distance: "95 miles south of Jaffrey",
      address: "2000 Post Rd, Warwick, RI 02886",
      note: "Convenient alternative with growing domestic and international routes. About 1 hour 45 minutes from Jaffrey via I-190 and I-295.",
      flightUrl: "https://www.flyri.com/",
      flightLabel: "PVD Airport",
      featured: false,
    },
  ],
};